import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const StockTable = ({ rows, handleEditRow, handleDeleteRow }) => {

    const getRiskRewardIndicator = (riskReward) => {
        if (isNaN(riskReward)) {
            return <span>-</span>; // Or some other placeholder if it's not a number
        }

        const riskRewardNumber = parseFloat(riskReward); // Ensure it's a number

        let indicator = null;
        if (riskRewardNumber > 0) {
            indicator = <span style={{ color: '#4caf50' }}>▲ {riskReward}</span>; // Green up arrow
        } else if (riskRewardNumber < 0) {
            indicator = <span style={{ color: '#f44336' }}>▼ {riskReward}</span>;   // Red down arrow
        } else {
            indicator = <span>0</span>; // Display "0" if it's zero
        }
        return indicator;
    };

    return (
        <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table sx={{ minWidth: 650 }} aria-label="stock table" size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell sx={{ bgcolor: 'primary.dark' }}>Stock Name</TableCell>
                        <TableCell align="right" sx={{ bgcolor: 'primary.dark' }}>Hold Unit</TableCell>
                        <TableCell align="right" sx={{ bgcolor: 'primary.dark' }}>Average Price</TableCell>
                        <TableCell align="right">Current Invest.</TableCell>
                        <TableCell align="right">New Unit</TableCell>
                        <TableCell align="right" sx={{ bgcolor: 'secondary.dark' }}>Current Price</TableCell>
                        <TableCell align="right" sx={{ bgcolor: 'secondary.dark' }}>New Investment</TableCell>
                        <TableCell align="right">New Average</TableCell>
                        <TableCell align="right">Average Benefit</TableCell>
                        <TableCell align="right">
                            <Tooltip title="Shows how much your new holding's value changes relative to the money you are risking." placement="top" arrow>
                                <span style={{ borderBottom: '1px dotted #ccc', cursor: 'help' }}>Risk/Reward</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell align="center">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.length > 0 ? (
                        rows.map((row, index) => (
                            <TableRow key={index} hover>
                                <TableCell component="th" scope="row">{index + 1}</TableCell>
                                <TableCell>{row.stockName}</TableCell>
                                <TableCell align="right">{row.holdUnit}</TableCell>
                                <TableCell align="right">{row.avgPrice}</TableCell>
                                <TableCell align="right">{row.currInvest}</TableCell>
                                <TableCell align="right">{row.newUnit}</TableCell>
                                <TableCell align="right">{row.currPrice}</TableCell>
                                <TableCell align="right">{row.newAmount}</TableCell>
                                <TableCell align="right">{row.newAvg}</TableCell>
                                <TableCell align="right">{row.benefit}</TableCell>
                                <TableCell align="right">{getRiskRewardIndicator(row.riskReward)} %</TableCell>
                                <TableCell align="center">
                                    <IconButton aria-label="edit" color="warning" onClick={() => handleEditRow(index)}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton aria-label="delete" color="error" onClick={() => handleDeleteRow(index)}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={12} align="center">
                                No data available
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default StockTable;
